import tool from '../../tools/tool'
import Api from '../../api/pay'

export default {
  namespace: 'payParams', // 注意定义namespace, 将会在store中存储
  state: {
    payParams: {},
    openId: '',
    // openId:'oMlrp1SKCuY77nTHKPhkr0vjqHVM',
    // openId:'pMlrp1dOyJr3GggntElsOKr2SjSQ',//126春元
    // openId: 'ojbYH5x7ItpG-WmgHqkPNt7yjLWI',
    // openId: 'oMlrp1fx1V72Y3Bb1VhiWHP7h36o',//符青
    // openId:'oMlrp1fKeQcwVEDqOBDy0-z3jBc0',
    // openId:'ojbYH57EvWobyC_GwKtw2jfvkSbE',
    // openId:'oMlrp1fOY0KF94tLuYdXNizx8R0c',//秋126
    // openId:'oMlrp1dKDcGsiICcNAYCjfPX1ljY', //袁杏全
    // openId:'oMlrp1fOY0KF94tLuYdXNizx8R0c', //卢秋荣
    // openId:'oMlrp1fofS7BGl_DhUNPBS-hNE04', //吴颖
    // openId:'o-69nw6M789qegUxa4wIHjGT5Hdg', //卢秋荣 10
    id: '',
    data: {},
    payMoney: {},
    plateNumId: '',
    payDetail: {},
    conpousSelect: [],
    conpousList: [],
    plateCarNumber: '',
    plateCarData: {},
    cashMon: '',
    temMonData: [],
    appType: 'wx',
    noPlateParams: {},
    totalAccountMoney: 0,
    applyInvoice: {},
    readySelectArr: [],
    invoiceDetailData: {},
    invoicSecondApplyData: {},
    invoiceOrderId: '',
    invoiceMoreInfo: {},
    scrollBottom: undefined, // 列表滚动的距离
    payParkId: '',
    isClickParklot: false,
    token: '',
    deptList: []
  },
  getters: {
    deptList: state => state.deptList,
    token: state => state.token,
    payParams: state => state.payParams,
    openId: state => state.openId,
    id: state => state.id,
    data: state => state.data,
    payMoney: state => state.payMoney,
    plateNumId: state => state.plateNumId,
    payDetail: state => state.payDetail,
    conpousSelect: state => state.conpousSelect,
    conpousList: state => state.conpousList,
    plateCarNumber: state => state.plateCarNumber,
    plateCarData: state => state.plateCarData,
    cashMon: state => state.cashMon,
    temMonData: state => state.temMonData,
    appType: state => state.appType,
    noPlateParams: state => state.noPlateParams,
    totalAccountMoney: state => state.totalAccountMoney,
    applyInvoice: state => state.applyInvoice,
    readySelectArr: state => state.readySelectArr,
    invoiceDetailData: state => state.invoiceDetailData,
    invoicSecondApplyData: state => state.invoicSecondApplyData,
    invoiceOrderId: state => state.invoiceOrderId,
    invoiceMoreInfo: state => state.invoiceMoreInfo,
    payParkId: state => state.payParkId,
    scrollBottom: state => state.scrollBottom,
    isClickParklot: state => state.isClickParklot
  },
  actions: {
    // actionsOpenId({commit,state},id){
    //     commit("getOpenId",'')
    //     commit("getPayParams",{})
    //     let href = window.location.href
    //     let urlParams = href.split("#/")[1]
    //     let url="https://tcct.grgyintong.com/#/"+urlParams
    //     let appid='wxf285ea85c975a59e'
    //     // let url="https://tcc.grgyintong.com/#/"+urlParams
    //     // let appid='wxfd559cd8f44405f1' //平云广场
    //     // let appid='wx1ce3ed8c30f71b9c' //旧的开发公众号
    //     let redirectUri = encodeURIComponent(url)
    //     window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo#wechat_redirect'
    //     Api.authorization(code).then(res => {
    //       let appid='wxf285ea85c975a59e'
    //       let data=res.data
    //       let openId=data.openId
    //       commit("getOpenId",openId)
    //       commit("getPayParams",data)
    //       this.$wechat.config({
    //         debug: false,
    //         appId:  data.appId,
    //         timestamp: data.timestamp,
    //         nonceStr:data.nonceStr, //随机串
    //         signature: data.signature,
    //         jsApiList: ['checkJsApi', 'chooseWXPay', 'getNetworkType', 'previewImage', 'openCard',
    //           'translateVoice', 'chooseImage', 'uploadImage', 'onMenuShareTimeline','addCard','hideOptionMenu','hideMenuItems'
    //         ]
    //       })
    //       this.$wechat.ready(function () {
    //         // this.$wechat.hideOptionMenu()
    //       })
    //     }).catch(err => {
    //       console.log(`err`, err)
    //     })
    // }
  },
  mutations: {
    getDeptList (state, value) {
      state.deptList = value
    },
    getToken (state, value) {
      state.token = value
    },
    getPayParams (state, value) {
      state.payParams = value
    },
    getOpenId (state, value) {
      state.openId = value
    },
    getId (state, value) {
      state.id = value
    },
    getData (state, value) {
      state.data = value
    },
    getPayMoney (state, value) {
      state.payMoney = value
    },
    getPlateNumId (state, value) {
      state.plateNumId = value
    },
    getPayDetail (state, value) {
      state.payDetail = value
    },
    getConpousSelect (state, value) {
      state.conpousSelect = value
    },
    getConpousList (state, value) {
      state.conpousList = value
    },
    getPlateCarNumber (state, value) {
      state.plateCarNumber = value
    },
    getPlateCarData (state, value) {
      state.plateCarData = value
    },
    getCash (state, value) {
      state.cashMon = value
    },
    getTemMonData (state, value) {
      state.temMonData = value
    },
    getAppType (state, value) {
      state.appType = value
    },
    getParams (state, value) {
      state.noPlateParams = value
    },
    getTotalAccountMoney (state, value) {
      state.totalAccountMoney = value
    },
    getApplyInvoice (state, value) {
      state.applyInvoice = value
    },
    getReadySelectArr (state, value) {
      state.readySelectArr = value
    },
    getInvoiceDetailData (state, value) {
      state.invoiceDetailData = value
    },
    getInvoicSecondApplyData (state, value) {
      state.invoicSecondApplyData = value
    },
    getInvoiceOrderId (state, value) {
      state.invoiceOrderId = value
    },
    getInvoiceMoreInfo (state, value) {
      state.invoiceMoreInfo = value
    },
    getScrollBottom (state, value) {
      state.scrollBottom = value
    },
    getPayParkId (state, value) {
      state.payParkId = value
    },
    isClickParklot (state, value) {
      state.isClickParklot = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payParams.js